import { Injectable } from '@angular/core';
import { QueryEntity, QueryConfig } from '@datorama/akita';
import { PurchaseStore, PurchaseState } from './purchase.store';
import { MemberPurchase } from './models/member-purchase.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
@QueryConfig({ sortBy: 'ExpirationDate' })
export class PurchaseQuery extends QueryEntity<PurchaseState> {
  constructor(protected store: PurchaseStore) {
    super(store);
  }

  selectPurchases(): Observable<MemberPurchase[]> {
    return this.selectAll();
  }

  selectPurchaseById(logId: number): Observable<MemberPurchase | undefined> {
    return this.selectEntity(logId);
  }

  selectRedeemedPurchases(): Observable<MemberPurchase[]> {
    return this.selectAll({ filterBy: (purchase) => purchase.RedeemStatus === 1 });
  }

  selectUnredeemedPurchases(): Observable<MemberPurchase[]> {
    return this.selectAll({ filterBy: (purchase) => purchase.RedeemStatus === 0 });
  }

  getPurchaseById(logId: number): MemberPurchase | undefined {
    return this.getEntity(logId);
  }
}
